import { Component, LineLocation, RelativeGeometry } from '@paragon/contract-library';
import { assertExhaustiveSwitch, makeWeakCache, notNullish } from '@paragon/utilities';

export function getAllMembers(component: Component) {
  return component.componentType === 'Wall' ? component.members : component.members.concat(component.braceMembers);
}

export const getAllMembersCached = makeWeakCache(getAllMembers);

export function getAllRelativeGeometries(component: Component) {
  const allMemberGeometries: readonly RelativeGeometry[] = getAllMembers(component)
    .map((member) => member.relativeGeometry)
    .filter(notNullish);
  const bearingGeometries = component.bearings.map((bearing) => bearing.relativeGeometry).filter(notNullish);
  return allMemberGeometries.concat(bearingGeometries);
}

export function getRelativeGeometryName(relativeGeometry: RelativeGeometry) {
  const { geometryType } = relativeGeometry;

  switch (geometryType) {
    case 'Member':
      return relativeGeometry.memberName;
    case 'Bearing':
      return relativeGeometry.bearingName;
    default:
      assertExhaustiveSwitch(geometryType);
  }
}

export function oppositeLineLocation(lineLocation: LineLocation): LineLocation {
  switch (lineLocation) {
    case 'Center':
      return 'Center';
    case 'Port':
      return 'Starboard';
    case 'Starboard':
      return 'Port';
    default:
      assertExhaustiveSwitch(lineLocation);
  }
}
